import * as React from 'react';

/**
 * How a bare value becomes a cell or a detail field, in one place.
 *
 * Empty is an em dash, not a blank: on a dense table a blank cell reads as a
 * rendering failure, and the two need to look different.
 */
export function formatValue(value: unknown): React.ReactNode {
  if (value === null || value === undefined || value === '') {
    return <span className="text-faint">—</span>;
  }
  if (typeof value === 'boolean') return value ? 'Sì' : 'No';
  if (typeof value === 'number') return value.toLocaleString('it-IT');
  if (typeof value === 'string') return value;
  if (value instanceof Date) return value.toLocaleDateString('it-IT');
  return JSON.stringify(value);
}

/** Same rules, flattened to a string — filter chips and aria labels use it. */
export function formatValueText(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'boolean') return value ? 'Sì' : 'No';
  if (typeof value === 'number') return value.toLocaleString('it-IT');
  if (typeof value === 'string') return value;
  if (value instanceof Date) return value.toLocaleDateString('it-IT');
  return JSON.stringify(value);
}
